import Image from "next/image";
import Overline from "~/componentsDS/Typography/Overline";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import type { StepItem } from "../data/types";

type HowItWorksStepCardProps = StepItem & {
    stepNumber: number;
};

const HowItWorksStepCard = ({ imageUrl, imageAlt, icon, title, description, stepNumber }: HowItWorksStepCardProps) => {
    return (
        <div className="flex flex-col w-full h-full rounded-2xl overflow-hidden bg-[linear-gradient(180deg,_#19223D_2.38%,_#2A3966_39.12%,_#A9B9E5_161.17%)]">
            <div className="relative h-[260px] md:h-[335px]">
                <Image
                    src={imageUrl}
                    alt={imageAlt || ""}
                    width={320}
                    height={300}
                    sizes="(max-width: 768px) 100vw, 560px"
                    className="
                        pointer-events-none absolute bottom-0 left-1/2
                        w-[82%] max-w-[260px] -translate-x-1/2
                        object-contain object-bottom
                        md:w-[79%] md:max-w-[320px]
                    "
                />
            </div>
            <div className="flex flex-1 gap-4 px-3 py-8 md:px-[14.4px] md:py-[21.6px] bg-gray100">
                <div className="shrink-0">
                    {icon}
                </div>
                <div className="flex flex-col flex-1">
                    <Overline weight="500" className="text-[12px] md:text-[15px] tracking-[0.96px] md:tracking-[1.21px] text-primary300 mb-3 md:mb-4">Step {stepNumber}</Overline>
                    <Heading as="h3" className="text-[18px] md:text-[20px] font-normal md:font-medium text-primary500 leading-[1.1] mb-1">{title}</Heading>
                    <Paragraph size="md" weight="400" className="text-primary500 ">{description}</Paragraph>
                </div>
            </div>
        </div>
    )
};

export default HowItWorksStepCard;
